import { render } from "./homenew.vue?vue&type=template&id=3a3ee324&scoped=true"
import script from "./homenew.vue?vue&type=script&lang=js"
export * from "./homenew.vue?vue&type=script&lang=js"

import "./homenew.vue?vue&type=style&index=0&id=3a3ee324&lang=scss&scoped=true"
import "./homenew.vue?vue&type=style&index=1&id=3a3ee324&lang=css"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3ee324"]])

export default __exports__